"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerCommentType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LedgerCommentType_Factory = /** @class */ (function () {
    function LedgerCommentType_Factory() {
    }
    LedgerCommentType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    LedgerCommentType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return LedgerCommentType_Factory;
}());
exports.LedgerCommentType_Factory = LedgerCommentType_Factory;
